export const CONTRACTORS = 'md_contractors_GLOBAL';